import { Box, CircularProgress } from '@material-ui/core';
import { useEffect } from 'react';

type LoadingSpinnerProps = {
  attachToRoot?: boolean;
};

const LoadingSpinner = ({ attachToRoot }: LoadingSpinnerProps) => {
  useEffect(() => {
    if (attachToRoot) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      if (attachToRoot) {
        document.body.style.overflow = 'auto';
      }
    };
  }, [attachToRoot]);
  if (attachToRoot) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          color: '#594684',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999,
          backgroundColor: '#ffffff40',
        }}
      >
        <CircularProgress color="inherit" size="4rem" />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 20,
        width: '100%',
        color: '#594684',
      }}
    >
      <CircularProgress color="inherit" size="4rem" />
    </Box>
  );
};
export default LoadingSpinner;
